// shared/ui/CatalogMultiSelect.jsx  (presentacional: select múltiple MUI ligado a react-hook-form; opciones por props)
import React from 'react';
import { Controller } from 'react-hook-form';
import { selectFieldSx } from './autocompleteSx.js';
import { Checkbox, FormControl, FormHelperText, InputLabel, ListItemText, MenuItem, Select } from '@mui/material';

const MENU_PROPS = { PaperProps: { style: { maxHeight: 300 } } };
const VALUE_STYLE = { minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };

// El valor del campo es siempre un array de ids numéricos. `error` = fieldError de RHF.
const CatalogMultiSelect = ({ id, name, control, label, options = [], placeholder, error, disabled = false }) => {
  const shrink = !!placeholder || undefined;
  return (
    <FormControl fullWidth style={{ marginTop: 3 }} error={!!error} sx={selectFieldSx}>
      <InputLabel id={`${id}-label`} shrink={shrink}>
        {label}
      </InputLabel>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value } }) => {
          const selected = value || [];
          return (
            <Select
              multiple
              labelId={`${id}-label`}
              id={id}
              label={label}
              disabled={disabled}
              displayEmpty={!!placeholder}
              notched={shrink}
              value={selected}
              onBlur={onBlur}
              onChange={event => {
                const v = event.target.value;
                const list = typeof v === 'string' ? v.split(',') : v;
                onChange(list.map(Number));
              }}
              renderValue={ids => {
                if (ids.length === 0) return <span style={{ color: '#9aa0a6' }}>{placeholder}</span>;
                const names = ids.map(item => (options.find(option => option.id === item) || {}).nombre).filter(Boolean);
                return <span style={VALUE_STYLE}>{names.join(', ')}</span>;
              }}
              MenuProps={MENU_PROPS}
              style={{ height: 44 }}>
              {options.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  <Checkbox checked={selected.indexOf(option.id) > -1} size="small" />
                  <ListItemText primary={option.nombre} />
                </MenuItem>
              ))}
            </Select>
          );
        }}
      />
      {error && <FormHelperText>{error.message}</FormHelperText>}
    </FormControl>
  );
};

export default CatalogMultiSelect;
